import SpriteSymbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-mindmap-detailed-view",
  "use": "icon-mindmap-detailed-view-usage",
  "viewBox": "0 0 24 24",
  "content": "<symbol viewBox=\"0 0 24 24\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" id=\"icon-mindmap-detailed-view\">\n<rect x=\"5\" y=\"6\" width=\"14\" height=\"12\" rx=\"1\" stroke=\"#B5BBC5\" stroke-width=\"2\" />\n<path d=\"M5 13L5 7C5 6.44772 5.44772 6 6 6L18 6C18.5523 6 19 6.44772 19 7L19 13C19 13.5523 18.5523 14 18 14L6 14C5.44772 14 5 13.5523 5 13Z\" stroke=\"#42526E\" stroke-width=\"2\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol